import {ActionWithoutPayload} from "../../@types/actions";
import {GET_SPORTS} from "../../constants/CommonConstants";

export const GetSportsAction = (): ActionWithoutPayload<any> => ({
    type: GET_SPORTS
});
